import * as e from "react";
const l = ({
  title: a,
  titleId: t,
  ...c
}) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": t,
    ...c
  },
  a ? /* @__PURE__ */ e.createElement("title", { id: t }, a) : null,
  /* @__PURE__ */ e.createElement("path", { d: "M1 12c0 5.439 3.972 9.961 9.167 10.878v-7.822h-2.75V12h2.75V9.556c0-2.75 1.772-4.278 4.277-4.278.795 0 1.65.122 2.445.244v2.811h-1.406c-1.344 0-1.65.673-1.65 1.528V12h2.934l-.49 3.056h-2.444v7.822C19.028 21.96 23 17.438 23 12c0-6.05-4.95-11-11-11S1 5.95 1 12" })
);
export {
  l as default
};
